var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "17px",
    viewBox: "0 0 27 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3338F7B9-80BE-4A32-AFF8-6C015E07D32C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---15---Payment---1-",
    transform: "translate(-780.000000, -576.000000)",
    fill: "#F6931E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(100.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-2",
    transform: "translate(646.000000, 414.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(20.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-video-1363425",
    transform: "translate(14.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3038391,0.684460695 C24.7817459,0.408093236 24.1675137,0.438729433 23.6760512,0.745946984 L18.6085192,3.97064534 L18.6085192,3.51003839 C18.6085192,1.57506581 17.0422121,0.00875868373 15.1072395,0.00875868373 L4.05056673,0.00875868373 C2.11559415,0.00875868373 0.54928702,1.57506581 0.54928702,3.51003839 L0.54928702,12.7239324 C0.54928702,14.6589049 2.11559415,16.2252121 4.05056673,16.2252121 L15.1072395,16.2252121 C17.0422121,16.2252121 18.6085192,14.6589049 18.6085192,12.7239324 L18.6085192,12.2939616 L23.6454479,15.4880018 C23.9218154,15.6722468 24.1981718,15.7337331 24.5054113,15.7337331 C24.7817788,15.7337331 25.0581353,15.6722468 25.2732358,15.5494881 C25.8259598,15.2731207 26.1331993,14.6895247 26.1331993,14.1059781 L26.1331993,2.1279159 C26.1638349,1.51371115 25.8259817,0.960767824 25.303894,0.68440585 L25.3038391,0.684460695 Z M24.8123821,14.0753199 C24.8123821,14.1980786 24.7508958,14.290415 24.6281371,14.3516874 C24.5360146,14.4131737 24.4438921,14.382323 24.3517697,14.3516874 L18.5777294,10.6967879 L18.5777294,5.56772029 L24.3517697,1.85134004 C24.4438921,1.78985375 24.5360146,1.78985375 24.6281371,1.85134004 C24.7202596,1.91282633 24.7817459,2.00494881 24.7817459,2.1277075 L24.8123821,14.0753199 Z M17.287702,3.51005484 L17.287702,12.7239488 C17.287702,13.921755 16.304777,14.9046801 15.1069707,14.9046801 L4.05029799,14.9046801 C2.85249177,14.9046801 1.86956673,13.921755 1.86956673,12.7239488 L1.86978095,3.51005484 C1.86978095,2.31224863 2.852706,1.32932358 4.05051221,1.32932358 L15.107185,1.32932358 C16.3049912,1.36017367 17.287702,2.34285192 17.287702,3.51005484 L17.287702,3.51005484 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.e7bf1bbdca86e411b102787615f7f939.svg";
export { ForwardRef as ReactComponent };